import { Box, Container, Typography, useMediaQuery, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'
import CustomButton from '../../../../../Components/CustomButton/CustomButton'
import { makeGetRequest, makePostRequest } from '../../../../../utils/api'
import urls from '../../../../../utils/urls'
import CreateOperationForm from './CreateOperationForm'
import ListOperations from './ListOperations'
import EditOperationForm from './EditOperationForm'
import RemoveIcon from '@mui/icons-material/Remove'
import AddIcon from '@mui/icons-material/Add'
import EditIcon from '@mui/icons-material/Edit'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'
import AddCircleIcon from '@mui/icons-material/AddCircle'

export const Ingredients = ({ recette }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [operations, setOperations] = useState({})
  const [operationsTemp, setOperationsTemp] = useState({})
  const [selectedRowsParams, setSelectedRowsParams] = useState({})
  const [selectedRows, setSelectedRows] = useState([])
  const [loading, setLoading] = useState(false)
  const [selected, setSelected] = useState(false)
  const [personne, setPersonne] = useState(recette.Servir ? recette.Servir : 0)

  useEffect(() => {
    fetchOperations()
  }, [])

  const fetchOperations = async (pagination = '') => {
    setLoading(true)
    let url = `${urls.crudBillofingredientsOperations}?RecipeId=${recette.id}`

    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperations({ ...response.data })
      setOperationsTemp({ ...response.data })
      setLoading(false)
    }
    setLoading(false)
  }

  const deleteBulkOperations = async () => {
    if (selectedRows.length === 0) {
      alert('Sélectionner une operation ')
    } else {
      const filteredOperations = operations.results.filter((v) => selectedRows.indexOf(v.id) === -1)
      setOperations({
        ...operations,
        results: filteredOperations,
        count: operations.count - selectedRows.length,
      })
      const response = await makePostRequest(
        urls.deleteBulkBillofIngredients,
        { selected: selectedRows },
        {},
        true,
      )
      if (response.status === 200) {
        console.log('Deleted Successfully')
      }
    }
  }

  const decreaseServir = () => {
    if (personne > 0) {
      setPersonne(personne - 1)
      let servir = recette.Servir > 0 ? recette.Servir : 1
      let op = []
      operationsTemp.results.filter((v) => {
        op.push({ ...v, Quantite: ((personne - 1) * v.Quantite) / servir })

        return ''
      })
      setOperations({
        ...operations,
        results: op,
      })
    }
  }
  const increaseServir = () => {
    setPersonne(personne + 1)

    let servir = recette.Servir > 0 ? recette.Servir : 1
    let op = []
    operationsTemp.results.filter((v) => {
      op.push({ ...v, Quantite: ((personne + 1) * v.Quantite) / servir })

      return ''
    })

    setOperations({
      ...operations,
      results: op,
    })
  }
  return (
    <>
      <Container maxWidth="xl" sx={{ px: isMobile ? 0 : 0 }}>
        <Box
          display={'flex'}
          alignItems={'center'}
          flexDirection={isMobile ? 'column-reverse' : 'row'}
        >
          <Box display="flex" fontSize={'12px'} alignItems={'center'}>
            <CustomButton onClick={decreaseServir} style={{ minWidth: 'unset' }}>
              <RemoveIcon />
            </CustomButton>
            <Typography
              sx={{
                whiteSpace: 'nowrap',
                textAlign: 'left',
                fontWeight: 600,
                padding: '10px',
              }}
            >
              {personne} personnes
            </Typography>
            <CustomButton onClick={increaseServir} style={{ minWidth: 'unset' }}>
              <AddIcon />
            </CustomButton>
          </Box>
          <Box marginLeft={'auto'} display="flex">
            {isMobile ? (
              <Box display={'flex'} gap={2} color={'white'}>
                <CreateOperationForm recette={recette} fetchOperations={fetchOperations} />
                <RemoveCircleIcon onClick={deleteBulkOperations} />
                <EditIcon
                  onClick={() => {
                    if (selectedRows.length === 1) {
                      setSelectedRowsParams({
                        ...operations.results.filter((v) => v.id === selectedRows[0]),
                      })
                      setSelected(true)
                    } else {
                      setSelected(false)
                      alert('Please Select one Ingredient for modifier')
                    }
                  }}
                />
              </Box>
            ) : (
              <Box>
                <CreateOperationForm recette={recette} fetchOperations={fetchOperations} />
                <CustomButton
                  onClick={() => {
                    if (selectedRows.length === 1) {
                      setSelectedRowsParams({
                        ...operations.results.filter((v) => v.id === selectedRows[0]),
                      })
                      setSelected(true)
                    } else {
                      setSelected(false)
                      alert('Please Select one Ingredient for modifier')
                    }
                  }}
                >
                  Modifier
                </CustomButton>

                <CustomButton onClick={deleteBulkOperations}>Supprimer</CustomButton>
              </Box>
            )}
          </Box>
        </Box>
        {selected ? (
          <EditOperationForm
            setSelected={setSelected}
            params={selectedRowsParams}
            fetchOperations={fetchOperations}
          />
        ) : (
          ''
        )}
        <ListOperations
          fetchOperations={fetchOperations}
          setSelectedRows={setSelectedRows}
          operations={operations}
        />
      </Container>
    </>
  )
}
